import React, { useState, useEffect, HtmlHTMLAttributes } from 'react';

type RenderType =
  | {
      render?: 'always' | 'idle';
      unmount?: 'never';
    }
  | {
      render?: 'lazy';
      unmount?: 'always' | 'idle' | 'never';
    };

export interface Props extends HtmlHTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  hidden: boolean;
  containerStyle?: React.CSSProperties;
  width?: number;
}

const TabPanel = (props: Props & RenderType) => {
  const { hidden, render, unmount, children, containerStyle } = props;

  const [shouldRender, setShouldRender] = useState(!hidden || render === 'always');

  useEffect(() => {
    if (!hidden || render === 'always') {
      setShouldRender(true);
    } else if (render === 'idle') {
      ('requestIdleCallback' in window ? requestIdleCallback : setTimeout)(() =>
        setShouldRender(true),
      );
    } else if (unmount === 'never') {
      setShouldRender(false);
    } else if (unmount === 'idle') {
      ('requestIdleCallback' in window ? requestIdleCallback : setTimeout)(() =>
        setShouldRender(false),
      );
    }
  }, [hidden, render, unmount]);

  return (
    <div
      id="tabpanel-wrapper"
      style={{
        height: '100%',
        ...containerStyle,
        display: shouldRender ? 'block' : 'none',
      }}
    >
      {children}
    </div>
  );
};

export default TabPanel;
